export const USER = {
  PERKFORCE_DOMAIN_UPDATE_INFO:
    'Perkforce domain change will take effect in next sign in.',
  DESCRIPTON_REQUIRED: 'Description is required.',
  CREATED: 'User Created.',
  NOT_FOUND: 'User not found.',
  VANITY_URL_EXISTS: 'Vanity url already occupied.',
  COMPANY_NAME_EXISTS: (type: string): string =>
    `${type || 'Company'} name already occupied.`,
  INVALID_TOKEN: 'Invalid token.',
  CODE_EXPIRED: 'Code is expired.',
  CODE_INVALID: 'Code is invalid.',
  LOGGED_OUT: 'User logged out.',
  UPDATED: 'User updated.',
  ORDER_EMAIL_RECIPIENTS_UPDATED: 'Order email recipients updated.',
  NOT_ONBOARDED: 'User not onboarded.',
  PHONE_CODE: (code: string, phoneNo: string): string =>
    `Please use this code ${code} to verify your phone number ${phoneNo}.`,
  INVALID_PHONE_ATTEMPT: (minutes: string): string =>
    `Sorry, you can’t sign up right now. You can try again in ${minutes}.`,
  PRIVACY_POLICY_RESET:
    'Terms, conditions and privacy policy reset done for all users.',
  ACTIVE_STATUS_UPDATED: 'User Active Status Updated Successfully.',
  DELETED: 'User Deleted Successfully.',
  CANNOT_DOWNGRADE_EMAIL_ORDER_RECIPIENT:
    'Can not remove superuser access, Please remove the user from order email recipient list first.',
  CANNOT_REMOE_LAST_EMAIL_ORDER_RECIPIENT:
    'Can not remove last order email recipient.',
  INVALID_EMPLOYER_ID:
    'Error Occurred, Invalid employer id, please try again later.',
  LOCATION_UPDATED: 'Location Updated Successfully.',
  FAILED_TO_FETCH_PERMISSIONS: 'Failed to fetch permissions, please try again.',
  NO_ROLE_ASSIGNED:
    "You currently don't have any roles assigned. Please contact the administrator for assistance.",
} as const;

export const USER_HISTORY = {
  CREATED: 'User history created.',
} as const;

export const EMPLOYEE = {
  CREATED: 'User created.',
  NOT_FOUND: 'User not found.',
  DELETED: 'User deleted.',
  UPDATED: 'User updated.',
  NO_FILE_FOUND: 'No file found to import users.',
  EMPLOYEES_IMPORT_SUCCESS: 'Users imported successfully.',
  EMPLOYEES_IMPORT_FAILED: 'Users import failed.',
  INVALID_FILE_TYPE: 'Invalid file type, upload csv file.',
  MAXIMUM_IMPORT_LIMIT: (importEmployeesLimit: string): string =>
    `Each import is restricted to a maximum of ${importEmployeesLimit} users.\nInstead, separate your file into smaller files and import multiple times.`,
  EMPLOYEES_EMAIL_COLUMN_NOT_FOUND: 'Users email column not found.',
  INVITE_SENT: 'Invite sent.',
} as const;

export const EMPLOYER = {
  EMPLOYEES_LANDING_CAT_CHANGED: 'Users landing category changed.',
} as const;

export const USER_FEEDBACK = {
  FEEDBACK_SUCCESS: 'Feedback submitted successfully.',
  FEEDBACK_FAILED: 'Feedback submission failed.',
} as const;
